<template>
  <template v-if="displayLocationDetail">
    <q-separator v-if="showSeparator" />
    <div
      v-bind="$attrs"
      class="column"
    >
      <div
        :class="$q.screen.gt.xs ? 'text-body1 text-bold' : 'text-body2 col-auto'"
      >
        {{ currentSite.displayName }}
      </div>
      <div
        v-if="!$_.isEmpty(currentSite.address1)"
        class="text-grey-7 text-body2"
        :style="{ 'line-height': compact ? '1.1' : undefined }"
      >
        {{ currentSite.address1 }}
      </div>
      <div
        v-if="displayCityStateZipInfo"
        class="text-grey-7 text-body2"
        :style="{ 'line-height': compact ? '1.1' : undefined }"
      >
        <template v-if="currentSite.city && (currentSite.state || currentSite.zip)">
          {{ currentSite.city }},
        </template>
        <template v-else-if="currentSite.city">
          {{ currentSite.city }}
        </template>
        {{ currentSite.state }} {{ currentSite.zip }}
      </div>
      <internal-or-external-link
        v-if="!$_.isEmpty(siteDirectionsHref) && !compact"
        :href="siteDirectionsHref"
        target="_blank"
        rel="noopener"
        class="text-capitalize q-my-md text-secondary"
      >
        <q-icon
          name="fal fa-map"
          class="q-mr-xs"
          size="16px"
        />
        {{ $t('actions.getDirections') }}
      </internal-or-external-link>
    </div>
  </template>
  <template v-if="displayPhoneInfo">
    <q-separator v-if="showSeparator" />
    <div
      v-bind="$attrs"
    >
      <internal-or-external-link
        v-if="!$_.isEmpty(currentSite?.phone) && !currentSite.consumerConfig.hidePhone"
        :href="`tel:${currentSite.phone}`"
        target="_blank"
        rel="noopener"
        class="text-capitalize q-my-md text-body2"
      >
        <q-icon name="fal fa-phone" />
        {{ currentSite.phone }}
      </internal-or-external-link>
    </div>
  </template>
</template>

<script>

import InternalOrExternalLink from 'src/modules/consumer/components/InternalOrExternalLink'

export default {
  name: 'CurrentSiteDetails',
  components: {
    InternalOrExternalLink
  },
  configuration: ['currentSite'],

  props: {
    showSeparator: {
      type: Boolean,
      required: false,
      default: false
    },
    compact: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    displayLocationDetail () {
      return !_.isEmpty(this.currentSite.displayName) ||
      !_.isEmpty(this.currentSite.address1) ||
      this.displayCityStateZipInfo
    },
    displayCityStateZipInfo () {
      return !_.isEmpty(this.currentSite.city) ||
      !_.isEmpty(this.currentSite.state) ||
      !_.isEmpty(this.currentSite.zip)
    },
    displayPhoneInfo () {
      return !_.isEmpty(this.currentSite?.phone) && !this.currentSite.consumerConfig.hidePhone && !this.compact
    },
    siteDirectionsHref () {
      const destination = encodeURI(`${this.currentSite.name} ${this.currentSite.address1} ${this.currentSite.city} ${this.currentSite.state} ${this.currentSite.zip}`)
      if (this.currentSite.consumerConfig.currentLocationDetailLinkUrl) {
        return this.$appendCurrentQueryParams(this.currentSite.consumerConfig.currentLocationDetailLinkUrl)
      } else {
        return `https://www.google.com/maps/dir/?api=1&destination=${destination}`
      }
    }
  }
}
</script>
